export default {"src":"/_next/static/media/TQQQ.f240b351.svg","height":18,"width":18};